import FileUploader from '../../lib/FileUploader'
import HttpRequest from '../../lib/HttpRequest'

const api = new HttpRequest('storage')
const actions = {
  upload ({ commit }, params = {}) {
    return new Promise((resolve, reject) => {
      const { files, path } = params
      const endpoint = api.getEndpoint(`upload?path=${path}`)
      const uploader = new FileUploader(files)

      commit('storage/uploading', true)

      uploader.send(endpoint)
        .then(res => {
          commit('storage/uploaded', {
            data: res.target.response,
            uploading: true
          })

          resolve(res.target.response)
        })
        .catch(error => {
          commit('storage/uploaded', {
            error,
            uploaded: false
          })

          reject(error)
        })
        .finally(() => commit('storage/uploading', false))
    })
  }
}

export default actions
